import { render } from "./award.vue?vue&type=template&id=ea50120c"
import script from "./award.vue?vue&type=script&lang=js"
export * from "./award.vue?vue&type=script&lang=js"

import "./award.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__